import { render, staticRenderFns } from "./authResult.vue?vue&type=template&id=2da9d04b&scoped=true"
import script from "./authResult.vue?vue&type=script&lang=js"
export * from "./authResult.vue?vue&type=script&lang=js"
import style0 from "./authResult.vue?vue&type=style&index=0&id=2da9d04b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9d04b",
  null
  
)

export default component.exports